import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper.js"

// First-run onboarding modal over the Gift Templates gallery. Opens itself on
// connect, plays the explainer video while the modal is up, and remembers the
// dismissal server-side when the user ticks "Don't show this again".
export default class extends Controller {
  static get targets() {
    return ["video", "dontShow"]
  }

  static get values() {
    return { dismissUrl: String, autoOpen: Boolean }
  }

  // The modal is always rendered so the "How template works?" button can reopen
  // it; only the first-run auto-open is gated on autoOpenValue.
  connect() {
    const $modal = $(this.element)
    $modal.on("shown.bs.modal", () => this.playVideo())
    $modal.on("hidden.bs.modal", () => this.onHidden())
    if (this.autoOpenValue) {
      this.autoOpenValue = false
      $modal.modal("show")
    }
  }

  disconnect() {
    $(this.element).off("shown.bs.modal hidden.bs.modal")
    this.pauseVideo()
  }

  playVideo() {
    if (!this.hasVideoTarget) {
      return
    }

    // Set muted from JS as well: some browsers only honour autoplay when the
    // property (not just the attribute) is set before playing.
    this.videoTarget.muted = true
    const played = this.videoTarget.play()
    if (played && played.catch) {
      played.catch(() => {})
    }
  }

  pauseVideo() {
    if (this.hasVideoTarget) {
      this.videoTarget.pause()
    }
  }

  onHidden() {
    this.pauseVideo()

    if (this.hasDontShowTarget && this.dontShowTarget.checked) {
      fetch(this.dismissUrlValue, RequestHelper.defaultPatchOptions())
        .catch(response => console.warn(response))
    }
  }
}
